/**
 * Generated by orval v7.9.0 🍺
 * Do not edit manually.
 * IntakeApp
 * OpenAPI spec version: v1
 */

export type InsuranceSearchType = typeof InsuranceSearchType[keyof typeof InsuranceSearchType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const InsuranceSearchType = {
  All: 'All',
  Electronic: 'Electronic',
  Paper: 'Paper',
} as const;
